<h2>Confirmation de suppression</h2>

<mat-divider></mat-divider>

<div class="text">
  <p>Souhaitez-vous supprimer cette procédure ?</p>
</div>
<div class="actions">
  <button mat-raised-button (click)="closeDialog()">Non</button>
  <button mat-raised-button class="button-validate" (click)="submitDialog()">Oui</button>
</div>